import { render, staticRenderFns } from "./producttokenlink.vue?vue&type=template&id=ac635644&"
import script from "./producttokenlink.vue?vue&type=script&lang=js&"
export * from "./producttokenlink.vue?vue&type=script&lang=js&"
import style0 from "./producttokenlink.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports